module.exports = __webpack_public_path__ + "img/logo-pc.c026827f.png";